export class ZeroEtlJobTableCounts {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "total",
            "baseName": "total",
            "type": "number",
            "format": ""
        },
        {
            "name": "succeeded",
            "baseName": "succeeded",
            "type": "number",
            "format": ""
        },
        {
            "name": "failed",
            "baseName": "failed",
            "type": "number",
            "format": ""
        },
        {
            "name": "superseded",
            "baseName": "superseded",
            "type": "number",
            "format": ""
        },
        {
            "name": "skipped",
            "baseName": "skipped",
            "type": "number",
            "format": ""
        },
        {
            "name": "pending",
            "baseName": "pending",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlJobTableCounts.attributeTypeMap;
    }
    constructor() {
    }
}
